import { Container, Row, Col, Card } from 'react-bootstrap';
import projImg1 from "../assets/img/wow.jpg";
import projImg2 from "../assets/img/mobile-app.jpg";
import projImg3 from "../assets/img/software-development.jpg";
import colorSharp from "../assets/img/color-sharp3.png";
import ScrollAnim from './ScrollAnim';


export const ServicesSection = () => {

    return (
        <section className="services" id="services">
       
            <Container>
                <div className="services-bx wow zoomIn">
                <ScrollAnim animation="animate__slideInDown"><h2 className="text-center mb-5">Other Services</h2></ScrollAnim>
                
                    <Row>
                    
                        <Col md={4}>
                           
                                <Card>
                            
                                    <Card.Img variant="top" src={projImg1} alt="Logo" />
                                
                                    <Card.Body>
                                        <Card.Title>Web Design & Development</Card.Title>
                                        <Card.Text>
                                        <ul className="list-group">
                                            <li className="list-group-item">E-Commerce</li>
                                            <li className="list-group-item">Multi-Level Marketing (MLM) </li>
                                            <li className="list-group-item">Travel and Tours</li>
                                            <li className="list-group-item">News</li>
                                            <li className="list-group-item">Hotel</li>
                                            <li className="list-group-item">ETC.</li>
                                        </ul>
                                        </Card.Text>
                                    
                                    </Card.Body>
                                </Card>
                           
                        </Col>
                  
                        <Col md={4}>
                            <Card>
                                <Card.Img variant="top" src={projImg2} />
                                <Card.Body>
                                    <Card.Title>Mobile App Development</Card.Title>
                                    <Card.Text>
                                    <ul className="list-group">
                                        <li className="list-group-item">E-Commerce</li>
                                        <li className="list-group-item">Food Deliveries</li>
                                        <li className="list-group-item">Package Deliveries</li>
                                        <li className="list-group-item">POS</li>
                                        <li className="list-group-item">Inventory</li>
                                        <li className="list-group-item">ETC.</li>
                                    </ul>
                                    </Card.Text>
                            
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card>
                                <Card.Img variant="top" src={projImg3} />
                                <Card.Body>
                                    <Card.Title>Software Development</Card.Title>
                                    <Card.Text>
                                    <ul className="list-group">
                                        <li className="list-group-item">POS</li>
                                        <li className="list-group-item">Billing </li>
                                        <li className="list-group-item">Payroll</li>
                                        <li className="list-group-item">MicroFinance</li>
                                        <li className="list-group-item">Inventory</li>
                                        <li className="list-group-item">ETC.</li>
                                    </ul>
                                    </Card.Text>
                                    
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Container>
            
            <img className="background-image-left" src={colorSharp} alt="Imagewow" />
        </section>
    )
}

